export default __webpack_public_path__ + "static/media/dollar.401b2e44.svg";